export default __webpack_public_path__ + "static/media/loading.33c39b63.gif";